export default __webpack_public_path__ + "static/media/team.c6a51b68.svg";